import EmployeeDocumentsForm from './EmployeeDocumentsForm';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { UploadDocumentButton } from 'framework/documentStorage';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { isEmployeeContractByType, isPolishOffice } from 'domain/shared/employee';
import { useEmployeeService } from 'domain/shared/employee';
import { UPLOAD_EMPLOYEE_DOCUMENTS } from '../constants';
import { EmployeeDocumentFormShowType } from '../types';

const UploadEmployeeDocButton = () => {
  const id = useEmployeeId();
  const { getById } = useEmployeeService();
  const { uploadDocument, getValidationSchema } = useDocumentStorageContext();

  const loadFormData = async (): Promise<Nullable<EmployeeDocumentFormShowType>> => {
    if (!id) {
      return null;
    }
    const employee = await getById(id);

    const isPolishContractEmployee =
      employee && isPolishOffice(String(employee.officeId)) && isEmployeeContractByType(String(employee.contractType));

    return {
      employeeAlias: id,
      // Only for validation
      isPolishContractEmployee,
    };
  };

  if (!id) {
    return null;
  }

  return (
    <UploadDocumentButton
      permission={UPLOAD_EMPLOYEE_DOCUMENTS}
      uploadMethod={uploadDocument}
      getDataFunc={loadFormData}
      getValidationSchemaFunc={getValidationSchema}
    >
      <EmployeeDocumentsForm />
    </UploadDocumentButton>
  );
};

export default UploadEmployeeDocButton;
